import { ApplicationError } from "@rocicorp/zero";
import * as Sentry from "@sentry/react";
import { withoutPerRequestDetail } from "../../shared/sentryFingerprint";
import { isUserFacingError } from "../../shared/userFacingError";
import { zeroDefinitionNotFoundDetails } from "../../shared/zeroErrors";
import { connectionErrorFingerprint } from "./zeroConnectionError";

export function zeroErrorFingerprint(
  logMessage: unknown,
  error: Error
): string[] | undefined {
  if (!(error instanceof ApplicationError)) {
    return logMessage === "Failed to connect"
      ? connectionErrorFingerprint(error.message)
      : undefined;
  }
  return [
    "zero-mutator",
    withoutPerRequestDetail(typeof logMessage === "string" ? logMessage : ""),
    withoutPerRequestDetail((error.message.split("\n")[0] ?? "").trim()),
  ];
}

export const zeroLogger = {
  logLevel: "error" as const,
  logSink: {
    log: (
      level: "error" | "warn" | "info" | "debug",
      context: Record<string, unknown> | undefined,
      ...args: unknown[]
    ) => {
      console.warn(level, context, ...args);
      if (level !== "error") return;

      const error = args.find((arg): arg is Error => arg instanceof Error);
      if (
        !error ||
        isUserFacingError(error) ||
        zeroDefinitionNotFoundDetails(error)
      ) {
        return;
      }
      const fingerprint = zeroErrorFingerprint(args[0], error);
      if (!fingerprint) return;
      Sentry.captureException(error, {
        tags: { source: "zero" },
        extra: { zeroContext: context, message: args[0] },
        fingerprint,
      });
    },
  },
};
